"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>Trips
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const MessageFooter_js_namespaceObject = require("../MessageFooter/MessageFooter.js");
var MessageFooter_js_default = /*#__PURE__*/ __webpack_require__.n(MessageFooter_js_namespaceObject);
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_TravelBotLogoImage_js_namespaceObject = require("../../TravelBotLogoImage.js");
const parseISO_namespaceObject = require("date-fns/parseISO");
const isFuture_namespaceObject = require("date-fns/isFuture");
const isToday_namespaceObject = require("date-fns/isToday");
const external_ListOfTrips_js_namespaceObject = require("./ListOfTrips.js");
const external_myTripDataContext_js_namespaceObject = require("./myTripDataContext.js");
const Trips_Trips = ({ trips = [], deepLinkPrompt, tripHeaderMsg = "I'm happy to help! Below are your trips, please select the one you need help with:", hasMoreTrips = false, displayInRealtimeVoice = false, submitChatMessageInMarkerComponent })=>{
    const currentTrips = [];
    const upcomingTrips = [];
    const pastTrips = [];
    const canceledTrips = [];
    trips.map((trip)=>{
        const checkStartDate = trip?.travelStartDate || new Date().toISOString();
        const checkEndDate = trip?.travelEndDate || new Date().toISOString();
        const travelStart = (0, parseISO_namespaceObject.parseISO)(checkStartDate);
        const travelEnd = (0, parseISO_namespaceObject.parseISO)(checkEndDate);
        const isCurrentTrip = !trip.isCanceled && ((0, isToday_namespaceObject.isToday)(travelStart) || !(0, isFuture_namespaceObject.isFuture)(travelStart) && (0, isFuture_namespaceObject.isFuture)(travelEnd));
        const isUpcomingTrip = !trip.isCanceled && !(0, isToday_namespaceObject.isToday)(travelStart) && (0, isFuture_namespaceObject.isFuture)(travelStart);
        const isPastTrip = !trip.isCanceled && !(0, isToday_namespaceObject.isToday)(travelStart) && !(0, isFuture_namespaceObject.isFuture)(travelStart) && !(0, isFuture_namespaceObject.isFuture)(travelEnd);
        if (isCurrentTrip) currentTrips.push(trip);
        else if (isUpcomingTrip) upcomingTrips.push(trip);
        else if (isPastTrip) pastTrips.push(trip);
        else if (trip.isCanceled) canceledTrips.push(trip);
    });
    if (displayInRealtimeVoice) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_myTripDataContext_js_namespaceObject.MyTripDataProvider, {
        currentTrips: currentTrips,
        upcomingTrips: upcomingTrips,
        pastTrips: pastTrips,
        canceledTrips: canceledTrips,
        deepLinkPrompt: deepLinkPrompt,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ListOfTrips_js_namespaceObject.ListOfDifferentTrips, {})
    });
    return trips?.length && !displayInRealtimeVoice ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_react_default().Fragment, {
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                mb: 3,
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.ChatMessage, {
                    ml: "",
                    mb: "8px",
                    variation: 'initial',
                    Icon: external_TravelBotLogoImage_js_namespaceObject.TravelBotLogoImage,
                    message: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                mb: 2,
                                children: tripHeaderMsg
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_myTripDataContext_js_namespaceObject.MyTripDataProvider, {
                                currentTrips: currentTrips,
                                upcomingTrips: upcomingTrips,
                                pastTrips: pastTrips,
                                canceledTrips: canceledTrips,
                                deepLinkPrompt: deepLinkPrompt,
                                submitChatMessageInMarkerComponent: submitChatMessageInMarkerComponent,
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ListOfTrips_js_namespaceObject.ListOfDifferentTrips, {})
                            })
                        ]
                    }),
                    footer: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(MessageFooter_js_default(), {})
                })
            }),
            hasMoreTrips ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                my: 3,
                ml: 3,
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Button, {
                    onClick: function() {
                        window.open('/next-profile/trips');
                    },
                    variation: "subtle",
                    children: "View All Trips"
                })
            }) : null
        ]
    }) : null;
};
const Trips = /*#__PURE__*/ (0, external_react_namespaceObject.memo)(Trips_Trips);
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
